var angular = require('angular');
var Promise = require('bluebird');

angular
	.module('app.directives')
	.directive('inlineEdit', function() {
		return {
			restrict: 'A',
			scope: true,
			link: function(scope, element, attrs) {
				element.addClass('inline-edit');

				// setup defaults
				scope.isOpen = false;
				scope.isInit = false;
				scope.isSubmit = false;

				scope.open = function() {
					scope.$broadcast('open');
				};

				// Open trigger
				attrs.openTrigger && scope.open();

				scope.$watch('isOpen', function(val) {
					scope.$emit('inline-edit', val, scope);
				});
			}
		};
	})

	.directive('inlinePreview', function($compile) {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				scope.$watch('isOpen', function(val) {
					element.css('display', val ? 'none' : '');
				});
			}
		};
	})

	.directive('inlinePreview', function($compile) {
		return {
			restrict: 'E',
			template: require('./preview.pug'),
			replace: true,
			transclude: true,
			scope: {
				title: '@',
				default: '@',
				value: '='
			},
			link: function(scope, element, attrs, ctrl, transclude) {
				scope.default = scope.default || 'Click here to set';
				scope.showMsg = true;

				scope.$watch('value', function(val) {
					scope.showMsg = typeof val == 'undefined' || val === null;
				});

				scope.$parent.$watch('isOpen', function(val) {
					element.css('display', val ? 'none' : '');
				});

				transclude(scope.$parent, function(clone, scope) {
					if (!clone.length) return;
					element
						.find('dd')
						.empty()
						.append(clone);
				});

				element.removeAttr('title');
				element.removeAttr('value');
			}
		};
	})

	.directive('inlineLoader', function() {
		return {
			restrict: 'A',
			template:
				'<i class="fa fa-circle-o-notch fa-spin green-text" style="margin:0 .5em"></i>',
			replace: true,
			link: function(scope, element, attrs) {
				var attr = attrs.inlineLoader;
				var map = {
					init: 'isInit',
					submit: 'isSubmit'
				};
				scope.$watch(map[attr], function(val) {
					element.css('display', val ? '' : 'none');
				});
			}
		};
	})
	.directive('inlineForm', function($timeout) {
		return {
			restrict: 'E',
			transclude: true,
			replace: true,
			template: require('./form.pug'),
			link: function(scope, element, attrs, ctrl, transclude) {
				scope.request = {};

				var ctrl = attrs.controller && scope.$eval(attrs.controller);
				if (ctrl) ctrl(scope);

				scope.$on('open', function() {
					scope.isInit = true;
					var init = attrs.init && scope.$eval(attrs.init);
					Promise.resolve(init).then(function(value) {
						if (value) scope.request = angular.copy(value);
						scope.isInit = false;
						scope.isOpen = true;
					});
				});

				scope.submit = function() {
					scope.isSubmit = true;
					element.find('input').attr('disabled', 'disabled');
					element.find('select').attr('disabled', 'disabled');
					element.find('textarea').attr('disabled', 'disabled');

					var submit = attrs.submit
						? scope.$eval(attrs.submit, scope)
						: null;

					Promise.resolve(submit)
						.then(function(value) {
							scope.form.$setPristine();
							scope.isOpen = false;
							scope.error = {};
						})
						.catch(function(err) {
							console.error(err);

							if (err instanceof Error) {
								scope.error = {
									label: err.message,
									json: err
								};
								return;
							}
							scope.error = { label: 'Error!', json: err };
						})
						.finally(function() {
							element.find('input').removeAttr('disabled');
							element.find('select').removeAttr('disabled');
							element.find('textarea').removeAttr('disabled');
							scope.isSubmit = false;
						});
				};

				scope.cancel = function(event) {
					event.preventDefault();
					scope.form.$setPristine();
					scope.isOpen = false;
					scope.error = {};
				};
			}
		};
	})
	.directive('inlineParent', function() {
		return {
			restrict: 'A',
			link: function(scope, element) {
				scope.$on('inline-edit', function($event, bool, sc) {
					scope.currentInlineEdit = bool ? sc : null;
					element.toggleClass('inline-edit-active', bool);
					element.toggleClass('inline-edit-inactive', !bool);
				});
			}
		};
	});
